import React from 'react'

import CardHeading from '@/components/typography/CardHeading'
import { cn } from '@/lib/utils'

type Props = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode
}

const TabTitle: React.FC<Props> = ({ className, ...props }) => (
  <CardHeading className={cn('mt-2 mb-4', className)} {...props} />
)

export default TabTitle
